// Deterministic avatar color + initials, ported from the design handoff (dashboard.js).
// Same hashing so a given name always maps to the same palette color.

const AVATAR_PALETTE = [
  "#28A745",
  "#1570EF",
  "#B54708",
  "#475467",
  "#17B26A",
  "#D92D20",
  "#7A5AF8",
  "#0E9384",
] as const;

export function avatarColor(name: string): string {
  let h = 0;
  for (const c of name) h = (h * 31 + c.charCodeAt(0)) % AVATAR_PALETTE.length;
  return AVATAR_PALETTE[h];
}

export function avatarInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "?";
  return trimmed
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}
